enum ETreeActionTypes {
  None = 0,
  Copy = 1,
  Cut = 2,
  Paste = 3,
  Delete = 4,
  Edit = 5,
}

export default ETreeActionTypes;
